module.exports = __webpack_public_path__ + "static/media/shapes-paths.3.b31cdc75.svg";